import React, { useCallback, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslations } from 'next-intl';

import MySJSimpleTitleBar from 'Components/Dumb/MySJSimpleTitleBar';
import { Image } from 'Components/Shared/UI';

import useStyles from './styles';

const scrollY = 0;

const ListItem = ({ data }) => {
  const t = useTranslations();
  const text = t.raw(data.link);

  const getDescription = useCallback(
    (desc, index) => (
      <p className="sub-title-content" key={desc + index}>
        {t(desc)}
      </p>
    ),
    [data],
  );

  const getDataTarget = useMemo(() => data.title.split(' ').join('-'), [data]);

  return (
    <div className="sft-info-list--item" data-scroll-view={getDataTarget}>
      <div className="list--item-image--wrapper">
        <Image src={data.imgSrc} />
      </div>
      <div className="lost--item-info-side">
        <h3 className="title-content">{t(data.title)}</h3>
        {data.description.constructor.name === 'Array'
          ? data.description.map((desc, index) => getDescription(desc, index))
          : getDescription(data.description, null)}
        {data.link ? (
          <div
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          ></div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

const List = ({ data, scrollView }) => {
  const t = useTranslations();
  const styles = useStyles();
  const parentRef = useRef();

  useEffect(() => {
    if (scrollView) {
      const getDataTarget = scrollView.split(' ').join('-');
      const target = parentRef.current?.querySelector(
        `[data-scroll-view="${getDataTarget}"]`,
      );

      const tillEnd = target?.getBoundingClientRect().top + scrollY - 100;

      window.scrollTo({
        top: tillEnd,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [scrollView]);

  return (
    <div>
      <MySJSimpleTitleBar>
        <div className="simple-bar_title">
          <h4 className="title-content">{t('safety_information_title')}</h4>
        </div>
      </MySJSimpleTitleBar>
      <div className={styles['safety-info--list-block']} ref={parentRef}>
        {data.map((l, index) => (
          <ListItem key={index + l.title} data={l} mainIndex={index + 1} />
        ))}
      </div>
    </div>
  );
};
List.propTypes = {
  data: PropTypes.array.isRequired,
};
export default React.memo(List);
